import Vue from 'vue'
import template from './index.pug'

export default Vue.extend({
  template: template(),

  data() {
    return {
      tableData: [
        {
          name: '901 Montinho da Conveniência – Castro Marim',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/901.pdf'
        },
        {
          name: '901 Casas da Alcaria – Castro Marim',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/901.pdf'
        },
        {
          name: '901 Casa Alta – Castro Marim',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/901.pdf'
        },
        {
          name: '901 Santa Rita – Vila Real de Santo António',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/901.pdf'
        },
        {
          name: '910 Cotovio – Albufeira',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/910.pdf'
        },
        {
          name: '911 Monte das Figueirinhas – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/911.pdf'
        },
        {
          name: '911 Boião – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/911.pdf'
        },
        {
          name: '911 Monte Ruivo – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/911.pdf'
        },
        {
          name: '911 Perna Seca de Cima – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/911.pdf'
        },
        {
          name: '911 Perna Seca de Baixo – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/911.pdf'
        },
        {
          name: '912 Alcoutim – Balurcos',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/912.pdf'
        },
        {
          name: '913 Benaciate – S. B. Messines',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/913.pdf'
        },
        {
          name: '913 Carvoeiro (X) – S. B. Messines',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/913.pdf'
        },
        {
          name: '913 Nora – S. B. Messines',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/913.pdf'
        },
        {
          name: '913 Fonte de Louseiros – S. B. Messines',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/913.pdf'
        },
        {
          name: '913 Torre e Cercas – S. B. Messines',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/913.pdf'
        },
        {
          name: '913 Benaciate – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/913.pdf'
        },
        {
          name: '913 Carvoeiro (X) – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/913.pdf'
        },
        {
          name: '913 Nora – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/913.pdf'
        },
        {
          name: '913 Fonte de Louseiros – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/913.pdf'
        },
        {
          name: '913 Torre e Cercas – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/913.pdf'
        },
        {
          name: '917 Odelouca – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/917.pdf'
        },
        {
          name: '917 Falacho – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/917.pdf'
        },
        {
          name: '917 Vale da Lama – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/917.pdf'
        },
        {
          name: '924 Cabeço do Velho – S. B. Alportel',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/924.pdf'
        },
        {
          name: '924 Bico Alto – S. B. Alportel',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/924.pdf'
        },
        {
          name: '927 Corte do Ouro – Loulé',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/927.pdf'
        },
        {
          name: '931 Vales de Pêra – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/931.pdf'
        },
        {
          name: '931 Montes Mourinhos – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/931.pdf'
        },
        {
          name: '931 Canas – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/931.pdf'
        },
        {
          name: '931 Poço Fundo - Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/931.pdf'
        },
        {
          name: '942 Fonte Salgada – Tavira',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/942.pdf'
        },
        {
          name: '945 Vale Covo – Loulé',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/945.pdf'
        },
        {
          name: '945 Alfeição – Loulé',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/945.pdf'
        },
        {
          name: '945 Vale Telheiro – Loulé',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/945.pdf'
        },
        {
          name: '947 Hortas do Tabual – Vila do Bispo',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/947.pdf'
        },
        {
          name: '963 Poço Longo – Olhão',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/963.pdf'
        },
        {
          name: '971 Fonte João Luís – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/971.pdf'
        },
        {
          name: '971 Vale Fuzeiros – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/971.pdf'
        },
        {
          name: '971 Barragem – Silves',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/971.pdf'
        },
        {
          name: '972 Águas Frias de Baixo – Loulé',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/972.pdf'
        },
        {
          name: '972 Zambujal – Loulé',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/972.pdf'
        },
        {
          name: '972 Malhão – Loulé',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/972.pdf'
        },
        {
          name: '972 Freixo de Baixo – Loulé',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/972.pdf'
        },
        {
          name: '972 Palmeiros – Loulé',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/972.pdf'
        },
        {
          name: '985 Quinta do Lago – Almancil',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/985.pdf'
        },
        {
          name: '989 Macheira – Loulé',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/989.pdf'
        },
        {
          name: '989 Soidos de Baixo – Loulé',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/989.pdf'
        },
        {
          name: '989 Monte Brito – Loulé',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/989.pdf'
        },
        {
          name: '989 Esteval de Mouros – Loulé',
          url: 'https://samoverickpro.blob.core.windows.net/static-files/files/vz/989.pdf'
        }
      ]
    }
  },
  methods: {
    redirectToShow(fileShowed) {
      if (fileShowed != null && fileShowed !== '') {
        window.open(fileShowed, '_blank')
      }
    },
    isValidHttpUrl(string) {
      let url

      try {
        url = new URL(string)
      } catch (_) {
        return false
      }

      return url.protocol === 'http:' || url.protocol === 'https:'
    }
  }
})
